<template>
  <div class="ArtworkStatusSelect mx-2">
    <div v-for="status in artwork_statuses" :key="status.value" class="flex mt-2">
      <label
        :for="`${status.value}-checkbox`"
        :class="isSelected(status.value) && 'active'"
        class="ArtworkStatusSelect_label capitalize font-normal my-2 flex items-center"
      >
        <input
          class="offscreen"
          type="checkbox"
          :id="`${status.value}-checkbox`"
          :value="status.value"
          @change="toggleCheckbox"
          :name="status.value"
          :checked="isSelected(status.value)"
        />

        <span class="inline-block mr-2 fa-layers fa-2x">
          <i class="fal fa-square unchecked"></i>
          <i class="fal fa-check-square checked"></i>
        </span>

        {{ status.label }}
      </label>

      <span class="ml-auto flex items-center" v-if="status.value == 'primary'">
        <span class="text-grey">(Direct from the Artist)</span>
      </span>
      <span class="ml-auto mr-2 flex items-center" v-else>
        <span class="text-grey">(Re-sale)</span>
      </span>
    </div>
  </div>
</template>

<script>
import ListingFilters from "@/lib/ListingFilters"

export default {
  name: "Side.ArtworkStatusSelect",
  props: {
    selected: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      artwork_statuses: ListingFilters.artwork_statuses,
    }
  },
  methods: {
    isSelected(value) {
      return this.selected.includes(value)
    },
    toggleCheckbox(e) {
      const { checked, value } = e.target
      checked ? this.add(value) : this.remove(value)
    },
    add(value) {
      this.$emit("select", { artwork_statuses: [...this.selected, value] })
    },
    remove(value) {
      this.$emit("select", { artwork_statuses: this.selected.filter((filter) => value !== filter) })
    },
  },
}
</script>

<style scoped>
.ArtworkStatusSelect_label .checked {
  display: none;
}

.ArtworkStatusSelect_label.active .unchecked {
  display: none;
}

.ArtworkStatusSelect_label.active .checked {
  @apply text-primary;
  display: inline-block;
}

svg * {
  stroke: #22292f;
}
</style>
